module.exports = __webpack_public_path__ + "img/mastercard.0d85f568.svg";